var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"np-inline-flex np-items-center np-justify-center np-rounded-sm np-tracking-wide",attrs:{"type":_vm.type,"disabled":_vm.isLoading}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }